/* @ngInject */
const axletree = (
  axletreeAsk,
  axletreeFormat,
  axletreeGo,
  axletreeLocal,
  axletreeMetadata,
  axletreeRequest,
  constants
) => {
  const self = {}

  self.ask = axletreeAsk
  self.format = axletreeFormat
  self.go = axletreeGo
  self.local = axletreeLocal
  self.metadata = axletreeMetadata
  self.request = axletreeRequest
  self.data = {
    myAxletrees: [],
  }

  self.new = (defaultWeight = 1300, _length = 0, ) => {
    let position = null
    position = constants.arrays.positions[_length]
    return {
      position: position,
      decision: 'Restitué',
      number: null,
      weight: defaultWeight,
      type: null,
      diameter: null,
      material: null,
    }
  }

  return self
}
export default axletree



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/axletree.service.js